import styled from 'styled-components';

export const ErrorBoundaryLayoutWrapper = styled.div`
  background-color: #e9ecef;
  text-align: center;
  padding: 100px 15%;
  line-height: 1.5;
`;
